export const SPANISH_TAXONOMY_TRANSLATIONS = {
  Construction: 'Construcción',
  Agricultural: 'Agricultura',
  'Livestock and By-Products': 'Ganadería y subproductos',
  Chemicals: 'Químicos',
  Housing: 'Vivienda',
  Equipment: 'Equipamiento',

  'Structural Materials': 'Materiales estructurales',
  'Aggregates and Binders': 'Agregados y aglutinantes',
  'Forestry Materials': 'Materiales forestales',
  'Metals and Alloys': 'Metales y aleaciones',
  'Masonry and Bricks': 'Mampostería y ladrillos',
  'Decorative Stone and Surfaces': 'Piedra decorativa y superficies',
  'Flooring and Paving': 'Pisos y pavimentos',
  'Construction Chemicals and Finishes': 'Químicos y acabados para construcción',
  'Electrical Materials': 'Materiales eléctricos',
  'Plumbing and Piping': 'Fontanería y tuberías',
  'Insulation, Waterproofing and Protection': 'Aislamiento, impermeabilización y protección',
  'Roofing Materials': 'Materiales para techos',
  'Glass and Glazing': 'Vidrio y acristalamiento',
  'Hardware and Fasteners': 'Herrajes y sujetadores',
  'Earthwork and Excavation Materials': 'Materiales para movimiento de tierra y excavación',
  'Formwork and Temporary Structures': 'Encofrados y estructuras temporales',
  'Doors, Windows and Facade Systems': 'Puertas, ventanas y sistemas de fachada',
  'Drainage and Stormwater Systems': 'Sistemas de drenaje y aguas pluviales',
  'Specialty Construction Products': 'Productos especializados para construcción',
  'Airport Construction Materials': 'Materias primas para construcción aeroportuaria',
  'Airport Gates and Boarding Bridge Materials': 'Materias primas para puertas y pasarelas de embarque',

  'Fertilizers and Nutrients': 'Fertilizantes y nutrientes',
  'Seeds and Planting Materials': 'Semillas y materiales de siembra',
  'Crop Protection and Pest Management': 'Protección de cultivos y control de plagas',
  'Animal Feed Ingredients': 'Ingredientes para alimento animal',
  'Soil and Growing Media': 'Suelos y medios de cultivo',
  'Agricultural Inputs': 'Insumos agrícolas',
  'Agricultural Machinery': 'Maquinaria agrícola',
  'Irrigation and Water Management': 'Riego y gestión del agua',
  'Greenhouse and Protected Agriculture': 'Invernaderos y agricultura protegida',
  'Post-Harvest and Storage': 'Poscosecha y almacenamiento',
  'Biological and Organic Inputs': 'Insumos biológicos y orgánicos',
  'Precision Agriculture': 'Agricultura de precisión',
  'Processed Crop Products': 'Productos agrícolas procesados',
  'Fruits and Vegetables': 'Frutas y verduras',
  'Oilseeds and Oils': 'Semillas oleaginosas y aceites',
  'Grains and Cereals': 'Granos y cereales',
  'Fibers and Textiles': 'Fibras y materias primas textiles',
  'Nuts and Spices': 'Frutos secos y especias',
  'Forestry Products': 'Productos forestales',

  'Live Animals': 'Animales vivos',
  'Animal Feed': 'Alimento animal',
  'Dairy Products': 'Productos lácteos',
  'Meat and Poultry': 'Carne y aves',
  'Animal By-Products, Hides and Fibers': 'Subproductos animales, pieles y fibras',
  'Animal Health and Veterinary Supplies': 'Salud animal y suministros veterinarios',
  'Livestock Equipment and Housing': 'Equipamiento e instalaciones ganaderas',
  'Eggs and Poultry Products': 'Huevos y productos avícolas',
  Beekeeping: 'Apicultura',
  Aquaculture: 'Acuicultura',
  'Farm Products': 'Productos de granja',

  'Acids, Bases and Caustic Soda': 'Ácidos, bases y soda cáustica',
  'Industrial Gases': 'Gases industriales',
  'Solvents and Alcohols': 'Solventes y alcoholes',
  Petrochemicals: 'Petroquímicos',
  Energy: 'Energía',
  'Household Chemicals': 'Químicos para el hogar',
  'Industrial and Inorganic Chemicals': 'Químicos industriales e inorgánicos',
  'Pharmaceutical Ingredients': 'Ingredientes farmacéuticos',
  Plastics: 'Plásticos',
  'Organic Chemicals': 'Químicos orgánicos',
  'Specialty Chemicals': 'Químicos especializados',
  'Fine Chemicals': 'Químicos finos',
  'Dyes and Pigments': 'Colorantes y pigmentos',
  Surfactants: 'Tensioactivos',
  Catalysts: 'Catalizadores',
  'Adhesives and Sealants': 'Adhesivos y selladores',
  Lubricants: 'Lubricantes',
  'Antifreeze and Coolants': 'Anticongelantes y refrigerantes',
  'Water Treatment Chemicals': 'Químicos para tratamiento de agua',
  'Rubber Chemicals': 'Químicos para caucho',
  'Food and Beverage Ingredients': 'Ingredientes para alimentos y bebidas',
  'Cosmetic and Personal Care Ingredients': 'Ingredientes cosméticos y de cuidado personal',
  'Coatings, Inks and Printing Chemicals': 'Recubrimientos, tintas y químicos de impresión',
  'Mining and Mineral Processing Chemicals': 'Químicos para minería y procesamiento de minerales',
  'Textile, Leather and Paper Chemicals': 'Químicos para textiles, cuero y papel',
  'Electronic and Semiconductor Chemicals': 'Químicos para electrónica y semiconductores',

  Decoration: 'Decoración',
  'Furniture Components': 'Componentes para muebles',
  'Kitchen and Bathroom Fixtures': 'Accesorios de cocina y baño',
  'Heating, Cooling and Ventilation': 'Calefacción, refrigeración y ventilación',
  'Residential Safety and Security': 'Seguridad y protección residencial',
  'Smart Home Components': 'Componentes para hogares inteligentes',
  'Water Storage and Sanitation': 'Almacenamiento de agua y saneamiento',
  'Modular and Prefabricated Components': 'Componentes modulares y prefabricados',
  'Residential Lighting and Electrical Fixtures': 'Iluminación y accesorios eléctricos residenciales',
  'Outdoor Living and Fencing': 'Espacios exteriores y cercas',
  'Accessibility and Mobility': 'Accesibilidad y movilidad',

  'Plastics and Polymers': 'Plásticos y polímeros',
  'Electronic Components': 'Componentes electrónicos',
  'Machinery Parts': 'Piezas de maquinaria',
  'Spring Manufacturing Materials': 'Materias primas para fabricación de resortes',
  'Rubber and Composites': 'Caucho y compuestos',
  'Hand and Power Tools': 'Herramientas manuales y eléctricas',
  'Heavy Machinery': 'Maquinaria pesada',
  'Packaging Materials': 'Materiales de embalaje',
  'Material Handling and Conveyors': 'Manejo de materiales y transportadores',
  'Safety Equipment': 'Equipos de seguridad',
  'Measurement and Testing': 'Medición y pruebas',
  'Lifting and Rigging': 'Elevación y aparejos',
  'Pumps and Valves': 'Bombas y válvulas',
  'Welding and Cutting': 'Soldadura y corte',
  'Compressors and Pneumatics': 'Compresores y neumática',
  'Generators and Power Systems': 'Generadores y sistemas de energía',
  'Automation Components': 'Componentes de automatización',
  'Electric Motors and Power Transmission': 'Motores eléctricos y transmisión de potencia',
  'Machine Tools and CNC': 'Máquinas herramienta y CNC',
  'Industrial Heating and Cooling': 'Calefacción y refrigeración industrial',
  'Storage and Warehousing': 'Almacenamiento y gestión de almacenes',
  'Maintenance and Spare Parts': 'Mantenimiento y repuestos',
  'Industrial Cleaning Equipment': 'Equipos de limpieza industrial',

  // Common subcategories shown throughout navigation, filters and product cards.
  'Steel Beams': 'Vigas de acero',
  'Reinforced Concrete': 'Concreto reforzado',
  'Aluminum Profiles': 'Perfiles de aluminio',
  'Aluminum Structures': 'Estructuras de aluminio',
  'Precast Concrete Elements': 'Elementos prefabricados de concreto',
  'Timber Frames': 'Estructuras de madera',
  'Composite Beams': 'Vigas compuestas',
  'Structural Steel Sections': 'Perfiles de acero estructural',
  Cement: 'Cemento',
  Sand: 'Arena',
  Gravel: 'Grava',
  'Crushed Stone': 'Piedra triturada',
  Lime: 'Cal',
  Lumber: 'Madera aserrada',
  Plywood: 'Madera contrachapada',
  'Engineered Wood': 'Madera de ingeniería',
  Bamboo: 'Bambú',
  'OSB Panels': 'Paneles OSB',
  'Particle Board': 'Tablero de partículas',
  'Steel Rebars': 'Varillas de acero',
  'Aluminum Sheets': 'Láminas de aluminio',
  'Copper Pipes': 'Tuberías de cobre',
  'Iron Bars': 'Barras de hierro',
  'Stainless Steel': 'Acero inoxidable',
  'Galvanized Steel': 'Acero galvanizado',
  'Metal Mesh': 'Malla metálica',
  'Runway Asphalt Binders': 'Ligantes asfálticos para pistas',
  'Airfield Cement and Concrete Inputs': 'Cemento e insumos para concreto aeroportuario',
  'Runway Aggregates': 'Agregados para pistas',
  'Airfield Geotextiles': 'Geotextiles para aeropuertos',
  'Runway Reinforcement Materials': 'Materiales de refuerzo para pistas',
  'Airfield Sealants and Joint Materials': 'Selladores y materiales para juntas aeroportuarias',
  'Airport Drainage Materials': 'Materiales para drenaje aeroportuario',
  'Structural Steel Profiles for Airport Gates': 'Perfiles de acero estructural para puertas aeroportuarias',
  'Aluminum Profiles for Boarding Bridges': 'Perfiles de aluminio para pasarelas de embarque',
  'Galvanized Steel Sheets for Boarding Bridges': 'Láminas de acero galvanizado para pasarelas de embarque',
  'Glass and Polycarbonate Panels for Boarding Bridges': 'Paneles de vidrio y policarbonato para pasarelas de embarque',
  'Rubber Seals and Flexible Canopy Materials': 'Sellos de caucho y materiales para marquesinas flexibles',
  'Anti-Slip Flooring Materials for Boarding Bridges': 'Materiales antideslizantes para pisos de pasarelas de embarque',
  'Weather-Resistant Cladding Materials': 'Materiales de revestimiento resistentes a la intemperie',
  'Copper Conductors and Cable Materials for Airport Gates': 'Conductores de cobre y materiales para cableado de puertas aeroportuarias',
  'Natural Textile Fibers': 'Fibras textiles naturales',
  'Synthetic Textile Fibers': 'Fibras textiles sintéticas',
  'Textile Yarns': 'Hilados textiles',
  'Sewing Threads': 'Hilos para costura',
  'Blanket and Knitting Yarns': 'Hilados para mantas y tejido',
  'Unfinished Textile Fabrics': 'Telas textiles sin terminar',
  'Textile Fillings and Batting': 'Rellenos y guatas textiles',
  'Spring Steel Wire': 'Alambre de acero para resortes',
  'Spring Steel Strip': 'Fleje de acero para resortes',
  'Spring Steel Rods': 'Barras de acero para resortes',
  'Stainless Spring Steel': 'Acero inoxidable para resortes',
  'Alloy Spring Steel': 'Acero aleado para resortes',
  'Non-Ferrous Spring Alloys': 'Aleaciones no ferrosas para resortes',
  'Clay Bricks': 'Ladrillos de arcilla',
  'Concrete Blocks': 'Bloques de concreto',
  'Ceramic Tiles': 'Baldosas de cerámica',
  'PVC Panels': 'Paneles de PVC',
  Paints: 'Pinturas',
  Blinds: 'Persianas',
  'Corn Seeds': 'Semillas de maíz',
  'Wheat Flour': 'Harina de trigo',
  'Soybean Oil': 'Aceite de soya',
  'Nitrogen Fertilizers': 'Fertilizantes nitrogenados',
  'Irrigation Pipes': 'Tuberías de riego',
  Hay: 'Heno',
  Straw: 'Paja',
  'Bovine Cattle': 'Ganado bovino',
  'Poultry Feed': 'Alimento para aves',
  'Leather Hides': 'Pieles de cuero',
  'Milk Powder': 'Leche en polvo',
  'Veterinary Vaccines': 'Vacunas veterinarias',
  Eggs: 'Huevos',
  Tallow: 'Sebo',
  'Sulfuric Acid': 'Ácido sulfúrico',
  Methanol: 'Metanol',
  Detergents: 'Detergentes',
  'Active Pharmaceutical Ingredients': 'Ingredientes farmacéuticos activos',
  'Caustic Soda': 'Soda cáustica',
  Disinfectants: 'Desinfectantes',
  Biodiesel: 'Biodiésel',
  'Light Structure': 'Estructura liviana',
  'Finishes and Coatings': 'Acabados y recubrimientos',
  'Roofs and Coverings': 'Techos y cubiertas',
  'Doors and Windows': 'Puertas y ventanas',
  'Waterproofing Membranes': 'Membranas impermeabilizantes',
  'Aluminum Windows': 'Ventanas de aluminio',
  Moldings: 'Molduras',
  'Tools and Equipment': 'Herramientas y equipos',
  Excavators: 'Excavadoras',
  Tractors: 'Tractores',
  Pallets: 'Tarimas',
  'Safety Helmets': 'Cascos de seguridad',
  'Plastic Film': 'Película plástica',
  'Hand Tools': 'Herramientas manuales',
  'Big Bags': 'Sacos grandes',

  // Farm Products (Ganadería y subproductos)
  'Chicken Coops and Poultry Houses': 'Gallineros y galpones avícolas',
  'Barns and Stables': 'Graneros y establos',
  'Livestock Shelters and Sheds': 'Galpones y refugios para ganado',
  'Pig Pens and Hog Houses': 'Chiqueros y porquerizas',
  'Rabbit Hutches': 'Conejeras',
  'Corrals and Livestock Fencing': 'Corrales y cercas para ganado',
  'Egg Incubators and Hatchery Equipment': 'Incubadoras de huevos y equipo de incubación',
  'Livestock Handling Chutes': 'Mangas de manejo de ganado',
  'Farm Construction Kits': 'Kits de construcción para fincas',
  'Silos and Feed Storage': 'Silos y almacenamiento de alimento',
  'Automatic Feeding Systems': 'Sistemas de alimentación automática',
  'Farm Water Troughs and Tanks': 'Bebederos y tanques de agua para finca',

  // Roller shutters (Construcción)
  'Roller Shutters and Metal Security Doors': 'Cortinas metálicas y puertas de seguridad',

  // Generators (Equipamiento)
  'Portable Generators': 'Generadores portátiles',
  'Standby Generators': 'Generadores de respaldo',

  // Complete seller taxonomy generated from the canonical sector data.
  "Asphalt Binders": "Aglutinantes de asfalto",
  "Fly Ash": "Cenizas volantes",
  "Slag Cement": "Cemento de escoria",
  "Brass Fittings": "Accesorios de latón",
  "Alloy Rods": "Varillas de aleación",
  "Aerated Concrete Blocks": "Bloques de hormigón celular",
  "Fire Bricks": "Ladrillos refractarios",
  "Natural Stone Masonry": "Albañilería de piedra natural",
  "Masonry Mortar": "Mortero de mampostería",
  "Marble": "Mármol",
  "Quartz": "Cuarzo",
  "Granite": "Granito",
  "Onyx": "Ónix",
  "Travertine": "Travertino",
  "Decorative Slate Slabs": "Losas de pizarra decorativas",
  "Terrazzo": "Terrazo",
  "Sintered Stone": "Piedra Sinterizada",
  "Limestone": "Caliza",
  "Soapstone": "Esteatita",
  "Quartzite": "Cuarcita",
  "Engineered Marble": "Mármol diseñado",
  "Porcelain Slabs": "Losas de porcelana",
  "Stone Veneer": "Chapa de piedra",
  "Stone Tiles": "Azulejos de piedra",
  "Decorative Tiles": "Azulejos Decorativos",
  "Concrete Pavers": "Adoquines de hormigón",
  "Paving Stones": "Adoquines",
  "Hardwood Flooring": "Pisos de madera",
  "Industrial Flooring": "Pisos industriales",
  "Concrete Admixtures": "Aditivos para hormigón",
  "Repair Mortars": "Morteros de Reparación",
  "Grouts": "Lechadas",
  "Curing Compounds": "Compuestos de curado",
  "Epoxy Repair Systems": "Sistemas de reparación epoxi",
  "Construction Adhesives": "Adhesivos para la construcción",
  "General Purpose Sealants": "Selladores de uso general",
  "Paints and Coatings": "Pinturas y Recubrimientos",
  "Plaster and Renders": "Yesos y Revoques",
  "Varnishes": "barnices",
  "Industrial Abrasives": "Abrasivos industriales",
  "Painting Tools and Accessories": "Herramientas y accesorios de pintura",
  "Paint Brushes and Rollers": "Pinceles y rodillos para pintar",
  "Paint Trays": "Bandejas de pintura",
  "Spray Paints": "Pinturas en aerosol",
  "Waterproof Coatings": "Recubrimientos impermeables",
  "Wood Paints and Coatings": "Pinturas y revestimientos para madera",
  "Interior and Exterior Paints": "Pinturas interiores y exteriores",
  "Sandpaper and Abrasive Sheets": "Papel de lija y hojas abrasivas",
  "Masking Tapes": "Cintas adhesivas",
  "Electrical Wires": "Cables electricos",
  "Cables": "cables",
  "Switches": "interruptores",
  "Circuit Breakers": "Disyuntores",
  "Conduits": "Conductos",
  "Lighting Fixtures": "Accesorios de iluminación",
  "Transformers": "transformadores",
  "Meter Bases": "Bases del medidor",
  "Electrical Boxes and Enclosures": "Cajas y gabinetes eléctricos",
  "Electrical Panels and Accessories": "Paneles Eléctricos y Accesorios",
  "Receptacles and Outlets": "Receptáculos y tomacorrientes",
  "Wall Plates": "Placas de pared",
  "Extension Cords": "Cables de extensión",
  "Surge Protectors": "Protectores contra sobretensiones",
  "Electrical Tape": "Cinta aislante",
  "Doorbells": "Timbres",
  "Conduit Accessories and Clamps": "Accesorios y abrazaderas para conductos",
  "PVC Pipes": "Tuberías de PVC",
  "Copper Tubes": "Tubos de cobre",
  "Fittings": "Guarniciones",
  "Valves": "válvulas",
  "Building Drainage Pipes": "Construcción de tuberías de drenaje",
  "Sanitary Ware Components": "Componentes de artículos sanitarios",
  "Water Heaters": "Calentadores de agua",
  "Gas Piping and Connections": "Tuberías y conexiones de gas",
  "PTFE and Plumbing Tapes": "Cintas de PTFE y plomería",
  "Plumbing Tools": "Herramientas de plomería",
  "Pressure Tanks": "Tanques de presión",
  "Water Tank Accessories": "Accesorios para tanques de agua",
  "Plumbing Adhesives": "Adhesivos para plomería",
  "Drain-Cleaning Tools": "Herramientas de limpieza de desagües",
  "Flexible Plumbing Connections": "Conexiones de plomería flexibles",
  "Fiberglass Insulation": "Aislamiento de fibra de vidrio",
  "Foam Insulation": "Aislamiento de espuma",
  "Waterproof Membranes": "Membranas impermeables",
  "Waterproofing Sealants": "Selladores impermeabilizantes",
  "Thermal Barriers": "Barreras Térmicas",
  "Acoustic Panels": "Paneles Acústicos",
  "Soundproofing Materials": "Materiales de insonorización",
  "Fireproofing Materials": "Materiales ignífugos",
  "Asphalt Shingles": "Tejas de asfalto",
  "Metal Roofing": "Techos Metálicos",
  "Clay Roof Tiles": "Tejas de arcilla",
  "Roofing Slate": "Pizarra para techos",
  "Roofing Felt": "Fieltro para techos",
  "Gutters": "Canalones",
  "Flashing": "Brillante",
  "Float Glass": "Vidrio flotado",
  "Tempered Glass": "Vidrio templado",
  "Laminated Glass": "Vidrio laminado",
  "Insulated Glass Units": "Unidades de vidrio aislante",
  "Mirrors": "espejos",
  "Glass Blocks": "Bloques de vidrio",
  "Nails": "Clavos",
  "Screws": "Tornillos",
  "Bolts": "Pernos",
  "Anchors": "Anclas",
  "Hinges": "Bisagras",
  "Locks": "Cerraduras",
  "Handles": "Manijas",
  "Padlocks": "Candados",
  "Door Hardware": "Herrajes para puertas",
  "Closet Hardware": "Hardware del armario",
  "Cabinet and Furniture Hardware": "Herrajes para gabinetes y muebles",
  "Door Closers": "Cierrapuertas",
  "Keys and Key Blanks": "Llaves y llaves sin cortar",
  "Fill Dirt": "Llenar la suciedad",
  "Topsoil": "Capa superficial del suelo",
  "Geotextiles": "Geotextiles",
  "Erosion Control Mats": "Esteras de control de erosión",
  "Retaining Wall Blocks": "Bloques de muro de contención",
  "Drainage Aggregates": "Agregados de drenaje",
  "Formwork Panels": "Paneles de encofrado",
  "Shoring Systems": "Sistemas de apuntalamiento",
  "Scaffolding": "Andamio",
  "Adjustable Props": "Accesorios ajustables",
  "Temporary Platforms": "Plataformas Temporales",
  "Safety Barriers": "Barreras de seguridad",
  "Commercial Doors": "Puertas Comerciales",
  "Window Systems": "Sistemas de ventanas",
  "Curtain Walls": "Muros cortina",
  "Storefront Systems": "Sistemas de escaparate",
  "Louvers": "Persianas",
  "Skylights": "claraboyas",
  "Facade Anchors": "Anclajes de fachada",
  "Drainage Channels": "Canales de drenaje",
  "Catch Basins": "Cuencas de captura",
  "Culverts": "Alcantarillas",
  "Stormwater Tanks": "Tanques de aguas pluviales",
  "Trench Drains": "Drenajes de trinchera",
  "Rainwater Management Systems": "Sistemas de gestión de agua de lluvia",
  "Sustainable Materials": "Materiales Sostenibles",
  "Recycled Aggregates": "Agregados Reciclados",
  "Smart Building Components": "Componentes de construcción inteligente",
  "Anti-Vibration Materials": "Materiales antivibración",
  "Expansion Joint Systems": "Sistemas de juntas de expansión",
  "Drywall and Gypsum Board": "Paneles de yeso y paneles de yeso",
  "Masonry Hand Tools": "Herramientas manuales de albañilería",
  "Wire Mesh and Construction Wire": "Malla de alambre y alambre de construcción",
  "Wheelbarrows and Site Carts": "Carretillas y carros de obra",
  "Utility Ropes and Hoses": "Cuerdas y mangueras utilitarias",
  "Rebar Bending Tools": "Herramientas para doblar barras de refuerzo",
  "Phosphate Fertilizers": "Fertilizantes fosfatados",
  "Potash Fertilizers": "Fertilizantes potásicos",
  "Organic Compost": "Abono Orgánico",
  "Trace Elements": "Oligoelementos",
  "Liquid Fertilizers": "Fertilizantes líquidos",
  "Slow-Release Fertilizers": "Fertilizantes de liberación lenta",
  "Foliar Nutrients": "Nutrientes foliares",
  "Wheat Seeds": "Semillas de trigo",
  "Rice Seeds": "Semillas de Arroz",
  "Sugarcane Cuttings": "Esquejes de caña de azúcar",
  "Vegetable Seeds": "Semillas de hortalizas",
  "Coffee Seeds": "Semillas de cafe",
  "Soybean Seeds": "Semillas de soja",
  "Sunflower Seeds": "Semillas De Girasol",
  "Cotton Seeds": "Semillas de algodon",
  "Pasture Seeds": "Semillas de pasto",
  "Flower Seeds": "Semillas de flores",
  "Hybrid Seeds": "Semillas Híbridas",
  "Organic Seeds": "Semillas Orgánicas",
  "Seedlings": "Plántulas",
  "Bulbs and Tubers": "Bulbos y tubérculos",
  "Rootstock": "Rizoma",
  "Insecticides": "Insecticidas",
  "Fungicides": "Fungicidas",
  "Herbicides": "herbicidas",
  "Rodenticides": "Rodenticidas",
  "Nematicides": "Nematicidas",
  "Biopesticides": "Biopesticidas",
  "Netting and Covers": "Redes y Cobertores",
  "Mulches": "mantillos",
  "Growth Regulators": "Reguladores de crecimiento",
  "Soil Fumigants": "Fumigantes del suelo",
  "Integrated Pest Management Tools": "Herramientas de manejo integrado de plagas",
  "Garden Pest-Control Equipment": "Equipo de control de plagas de jardín",
  "Corn Meal": "Harina de maíz",
  "Soybean Meal": "harina de soja",
  "Wheat Bran": "Salvado de trigo",
  "Molasses": "Melaza",
  "Fish Meal": "harina de pescado",
  "Alfalfa Hay": "Heno de Alfalfa",
  "Vitamin Supplements": "Suplementos vitamínicos",
  "Mineral Mixes": "Mezclas minerales",
  "Peat Moss": "turba",
  "Vermiculite": "vermiculita",
  "Perlite": "Perlita",
  "Coconut Coir": "Fibra de coco",
  "Composted Manure": "Estiércol compostado",
  "Sand Mixtures": "Mezclas de arena",
  "Hydroponic Substrates": "Sustratos hidropónicos",
  "Seedling Trays": "Bandejas de plántulas",
  "Plant Supports": "Soportes para plantas",
  "Agricultural Twine": "Cordel agrícola",
  "Soil Test Kits": "Kits de prueba de suelo",
  "pH Regulators": "Reguladores de pH",
  "Crop Markers": "Marcadores de cultivos",
  "Field Fencing": "Cercado de campo",
  "Harvesting Bags": "Bolsas de cosecha",
  "Agricultural Tools": "Herramientas agrícolas",
  "Harvesters": "Cosechadoras",
  "Plows": "Arados",
  "Sprayers": "Pulverizadores",
  "Seed Drills": "Sembradoras",
  "Cultivators": "Cultivadores",
  "Farm Machinery Parts": "Piezas de maquinaria agrícola",
  "Garden Hand Tools": "Herramientas manuales de jardín",
  "Lawn and Garden Power Equipment": "Equipos eléctricos para césped y jardín",
  "Pruning and Cutting Tools": "Herramientas de poda y corte",
  "Landscaping Tools": "Herramientas de paisajismo",
  "Drip Lines": "Líneas de goteo",
  "Emitters": "Emisores",
  "Irrigation Filters": "Filtros de riego",
  "Fertigation Systems": "Sistemas de fertirrigación",
  "Agricultural Water Tanks": "Tanques de agua agrícola",
  "Water Pumps": "Bombas de agua",
  "Irrigation Controllers": "Controladores de riego",
  "Garden Hoses and Sprinklers": "Mangueras de jardín y aspersores",
  "Greenhouse Films": "Películas de invernadero",
  "Shade Nets": "Redes de sombra",
  "Growing Benches": "Bancos de cultivo",
  "Climate Controls": "Controles climáticos",
  "Tunnel Structures": "Estructuras de túneles",
  "Greenhouse Frames": "Marcos de invernadero",
  "Ventilation Systems": "Sistemas de ventilación",
  "Grain Dryers": "Secadores de Granos",
  "Storage Silos": "Silos de almacenamiento",
  "Cold Storage Supplies": "Suministros de almacenamiento en frío",
  "Produce Crates": "producir cajas",
  "Moisture Control": "Control de humedad",
  "Sorting Equipment": "Equipo de clasificación",
  "Agricultural Packaging Supplies": "Suministros de embalaje agrícola",
  "Biofertilizers": "Biofertilizantes",
  "Biostimulants": "Bioestimulantes",
  "Microbial Inoculants": "Inoculantes microbianos",
  "Mycorrhizae": "Micorrizas",
  "Biological Pest Control": "Control biológico de plagas",
  "Organic Soil Amendments": "Enmiendas orgánicas del suelo",
  "Soil Sensors": "Sensores de suelo",
  "Weather Stations": "Estaciones meteorológicas",
  "GPS Guidance Systems": "Sistemas de guía GPS",
  "Agricultural Drones": "Drones agrícolas",
  "Remote Crop Monitoring": "Monitoreo remoto de cultivos",
  "Variable Rate Controllers": "Controladores de tasa variable",
  "Canned Fruits": "Frutas enlatadas",
  "Dried Vegetables": "Verduras Secas",
  "Refined Sugar": "Azúcar refinado",
  "Fruit Concentrates": "Concentrados de Frutas",
  "Milled Grains": "Granos Molidos",
  "Fresh Fruits": "frutas frescas",
  "Dried Fruits": "frutos secos",
  "Frozen Vegetables": "Verduras Congeladas",
  "Root Vegetables": "Verduras de raíz",
  "Leafy Greens": "Verduras de hoja verde",
  "Citrus Fruits": "frutas cítricas",
  "Palm Oil": "Aceite de palma",
  "Sunflower Oil": "Aceite de girasol",
  "Canola Oil": "Aceite de canola",
  "Olive Oil": "Aceite de oliva",
  "Essential Oils": "Aceites Esenciales",
  "Wheat": "Trigo",
  "Corn": "Maíz",
  "Rice": "Arroz",
  "Barley": "Cebada",
  "Oats": "Avena",
  "Millet": "Mijo",
  "Cotton Fiber": "Fibra de algodon",
  "Jute": "Yute",
  "Hemp": "Cáñamo",
  "Flax": "Lino",
  "Sisal": "Sisal",
  "Almonds": "Almendras",
  "Cashews": "anacardos",
  "Pepper": "Pimienta",
  "Cinnamon": "Canela",
  "Cloves": "clavo",
  "Nutmeg": "Nuez moscada",
  "Timber Logs": "Troncos de madera",
  "Wood Pulp": "Pulpa de madera",
  "Resins": "Resinas",
  "Essential Woods": "Maderas esenciales",
  "Cattle": "Ganado",
  "Poultry (Chickens)": "Aves (pollos)",
  "Goats": "cabras",
  "Sheep": "Oveja",
  "Pigs": "cerdos",
  "Rabbits": "Conejos",
  "Horses": "caballos",
  "Concentrates": "Concentrados",
  "Forage": "Forraje",
  "Supplements": "Suplementos",
  "Silage": "Ensilaje",
  "Cattle Feed": "Alimentación del ganado",
  "Mineral Blocks": "Bloques minerales",
  "Cheese Bases": "Bases de queso",
  "Butter Fat": "Grasa en Mantequilla",
  "Whey Protein": "Proteína de suero",
  "Raw Milk": "leche cruda",
  "Cream": "Crema",
  "Dairy Cultures": "Cultivos lácteos",
  "Beef Cuts": "Cortes de carne",
  "Chicken Parts": "Partes de pollo",
  "Pork": "Cerdo",
  "Lamb": "Cordero",
  "Processed Meat": "Carne Procesada",
  "Frozen Poultry": "Aves Congeladas",
  "Animal Hides": "Pieles de animales",
  "Bones and Horns": "Huesos y cuernos",
  "Wool": "Lana",
  "Gelatin Raw Materials": "Materias primas de gelatina",
  "Feathers": "Plumas",
  "Blood Meal": "harina de sangre",
  "Antiparasitics": "Antiparasitarios",
  "Veterinary Antibiotics": "Antibióticos veterinarios",
  "Animal Disinfectants": "Desinfectantes animales",
  "Diagnostic Tests": "Pruebas de Diagnóstico",
  "Veterinary Instruments": "Instrumentos veterinarios",
  "Wound Care Supplies": "Suministros para el cuidado de heridas",
  "Feeders": "Comederos",
  "Drinkers": "Bebederos",
  "Pens and Gates": "Corrales y puertas",
  "Milking Equipment": "Equipo de ordeño",
  "Barn Ventilation": "Ventilación del granero",
  "Animal Transport Cages": "Jaulas de transporte de animales",
  "Livestock Scales": "Básculas para ganado",
  "Table Eggs": "huevos de mesa",
  "Hatching Eggs": "huevos para incubar",
  "Egg Powder": "huevo en polvo",
  "Liquid Egg Products": "Productos de huevo líquidos",
  "Poultry By-Products": "Subproductos avícolas",
  "Beehives": "colmenas",
  "Honey": "Miel",
  "Beeswax": "Cera de abejas",
  "Bee Feed": "Alimentación de abejas",
  "Beekeeping Protective Equipment": "Equipo de protección de apicultura",
  "Honey Extraction Equipment": "Equipos de extracción de miel",
  "Live Fish and Fingerlings": "Peces vivos y alevines",
  "Shrimp and Crustaceans": "Camarones y Crustáceos",
  "Aquaculture Feed": "Alimentación para acuicultura",
  "Aeration Systems": "Sistemas de aireación",
  "Nets and Cages": "Redes y Jaulas",
  "Aquaculture Pumps": "Bombas de acuicultura",
  "Tanks and Pond Liners": "Tanques y revestimientos para estanques",
  "Water Quality Testing": "Pruebas de calidad del agua",
  "Hydrochloric Acid": "Ácido clorhídrico",
  "Nitric Acid": "Ácido nítrico",
  "Acetic Acid": "Ácido acético",
  "Phosphoric Acid": "Ácido fosfórico",
  "Ammonia": "Amoníaco",
  "Potassium Hydroxide": "hidróxido de potasio",
  "Sodium Hydroxide Flakes": "Escamas de hidróxido de sodio",
  "Sodium Hydroxide Pearls": "Perlas de hidróxido de sodio",
  "Sodium Hydroxide Liquid Solution": "Solución líquida de hidróxido de sodio",
  "Food-Grade Caustic Soda": "Soda cáustica de calidad alimentaria",
  "Industrial-Grade Caustic Soda": "Soda cáustica de grado industrial",
  "Nitrogen": "Nitrógeno",
  "Oxygen": "Oxígeno",
  "Hydrogen": "Hidrógeno",
  "Carbon Dioxide": "Dióxido de carbono",
  "Argon": "Argón",
  "Helium": "Helio",
  "Acetylene": "Acetileno",
  "Propane": "Propano",
  "Ethanol": "Etanol",
  "Acetone": "Acetona",
  "Toluene": "tolueno",
  "Isopropanol": "isopropanol",
  "Ethyl Acetate": "Acetato de etilo",
  "Xylene": "xileno",
  "Butanol": "butanol",
  "Paint Thinners": "Diluyentes de pintura",
  "Ethylene": "Etileno",
  "Propylene": "propileno",
  "Benzene": "Benceno",
  "Styrene": "estireno",
  "Butadiene": "Butadieno",
  "Cumene": "cumeno",
  "Phenol": "Fenol",
  "Crude Oil": "Petróleo crudo",
  "Natural Gas": "Gas natural",
  "Coal": "Carbón",
  "Biofuels": "Biocombustibles",
  "Kerosene": "Queroseno",
  "Diesel Fuel": "Gasóleo",
  "Gasoline": "Gasolina",
  "Liquefied Petroleum Gas": "Gas licuado de petróleo",
  "Bleach": "Lejía",
  "Ammonia Solution": "Solución de amoníaco",
  "Baking Soda": "Bicarbonato",
  "Vinegar": "Vinagre",
  "Dish Soap": "Jabón para platos",
  "Laundry Detergents": "Detergentes para ropa",
  "Glass Cleaners": "Limpiadores de vidrio",
  "Drain Cleaners": "Limpiadores de desagües",
  "Household Disinfectants": "Desinfectantes domésticos",
  "General Detergents": "Detergentes generales",
  "Chlorine": "Cloro",
  "Sodium Chloride": "Cloruro de sodio",
  "Calcium Carbonate": "Carbonato de calcio",
  "Titanium Dioxide": "Dióxido de titanio",
  "Alumina": "Alúmina",
  "Silica": "Sílice",
  "Zinc Oxide": "Óxido de zinc",
  "Iron Oxide": "Óxido de hierro",
  "Halides": "Haluros",
  "Sulfates": "Sulfatos",
  "Nitrates": "nitratos",
  "Phosphates": "Fosfatos",
  "Silicates": "silicatos",
  "Analgesic APIs": "API analgésicos",
  "Antibiotic APIs": "API de antibióticos",
  "Vitamin APIs": "API de vitaminas",
  "Hormone APIs": "API hormonales",
  "Antiviral APIs": "API antivirus",
  "Oncology APIs": "API de oncología",
  "Excipients": "Excipientes",
  "Intermediates": "Intermedios",
  "Solvents for Pharma": "Solventes para farmacia",
  "Pharmaceutical Preservatives": "Conservantes farmacéuticos",
  "Stabilizers": "Estabilizadores",
  "Binders": "Aglutinantes",
  "Coatings": "Recubrimientos",
  "Buffers": "Soluciones tampón",
  "Polyethylene": "Polietileno",
  "Polypropylene": "polipropileno",
  "PVC": "Policloruro de vinilo (PVC)",
  "PET": "Tereftalato de polietileno (PET)",
  "Polystyrene": "Poliestireno",
  "ABS": "ABS",
  "Nylon": "Nylon",
  "Polycarbonate": "policarbonato",
  "Filamento PLA": "Filamento PLA",
  "Filamento PETG": "Filamento PETG",
  "Filamento ABS": "Filamento ABS",
  "Filamento TPU": "Filamento TPU",
  "Alkanes": "alcanos",
  "Alkenes": "alquenos",
  "Alkynes": "alquinos",
  "Aromatics": "Aromáticos",
  "Alcohols": "alcoholes",
  "Aldehydes": "Aldehídos",
  "Ketones": "Cetonas",
  "Carboxylic Acids": "Ácidos carboxílicos",
  "Flame Retardants": "Retardantes de llama",
  "Chelating Agents": "Agentes quelantes",
  "UV Stabilizers": "Estabilizadores UV",
  "Foaming Agents": "Agentes espumantes",
  "Fertilizer Additives": "Aditivos para fertilizantes",
  "Industrial Waxes": "Ceras Industriales",
  "Reagents": "reactivos",
  "Catalysts for Lab": "Catalizadores para laboratorio",
  "High-Purity Solvents": "Solventes de alta pureza",
  "Intermediates for Synthesis": "Intermedios para la síntesis",
  "Custom Chemicals": "Productos químicos personalizados",
  "Azo Dyes": "Colorantes azoicos",
  "Reactive Dyes": "Tintes reactivos",
  "Pigment Blue": "pigmento azul",
  "Pigment Red": "pigmento rojo",
  "Organic Pigments": "pigmentos organicos",
  "Inorganic Pigments": "pigmentos inorgánicos",
  "Disperse Dyes": "Tintes dispersos",
  "Anionic Surfactants": "Tensioactivos aniónicos",
  "Cationic Surfactants": "Tensioactivos catiónicos",
  "Nonionic Surfactants": "Surfactantes no iónicos",
  "Amphoteric Surfactants": "Surfactantes anfóteros",
  "Sodium Lauryl Sulfate": "Lauril sulfato de sodio",
  "Tween": "Tween",
  "Span": "Span",
  "Heterogeneous Catalysts": "Catalizadores heterogéneos",
  "Homogeneous Catalysts": "Catalizadores homogéneos",
  "Enzyme Catalysts": "Catalizadores enzimáticos",
  "Zeolites": "Zeolitas",
  "Platinum Catalysts": "Catalizadores de platino",
  "Nickel Catalysts": "Catalizadores de níquel",
  "Epoxy Adhesives": "Adhesivos Epoxi",
  "Polyurethane Sealants": "Selladores de poliuretano",
  "Silicone Sealants": "Selladores de silicona",
  "Acrylic Adhesives": "Adhesivos Acrílicos",
  "Hot Melt Adhesives": "Adhesivos termofusibles",
  "Cyanoacrylate": "cianoacrilato",
  "Industrial Resins": "Resinas Industriales",
  "Mineral Oils": "Aceites minerales",
  "Synthetic Lubricants": "Lubricantes sintéticos",
  "Greases": "Grasas",
  "Hydraulic Fluids": "Fluidos hidráulicos",
  "Gear Oils": "Aceites para engranajes",
  "Compressor Oils": "Aceites para compresores",
  "Coagulants": "Coagulantes",
  "Flocculants": "Floculantes",
  "pH Adjusters": "Ajustadores de pH",
  "Scale Inhibitors": "Inhibidores de incrustaciones",
  "Corrosion Inhibitors": "Inhibidores de corrosión",
  "Biocides": "Biocidas",
  "Activated Carbon": "Carbón activado",
  "Ion Exchange Resins": "Resinas de intercambio iónico",
  "Defoamers": "Antiespumantes",
  "Oxygen Scavengers": "Eliminadores de oxígeno",
  "Membrane Cleaners": "Limpiadores de membranas",
  "Accelerators": "Aceleradores",
  "Rubber Antioxidants": "Antioxidantes de caucho",
  "Vulcanizing Agents": "Agentes vulcanizantes",
  "Fillers": "Cargas",
  "Plasticizers": "Plastificantes",
  "Processing Aids": "Ayudas de procesamiento",
  "Preservatives": "conservantes",
  "Sweeteners": "Edulcorantes",
  "Emulsifiers": "Emulsionantes",
  "Food Colorants": "Colorantes alimentarios",
  "Acidity Regulators": "Reguladores de acidez",
  "Flavoring Agents": "Agentes aromatizantes",
  "Food-Grade Stabilizers": "Estabilizadores de calidad alimentaria",
  "Fragrances": "Fragancias",
  "Emollients": "Emolientes",
  "Humectants": "Humectantes",
  "Cosmetic Preservatives": "Conservantes cosméticos",
  "UV Filters": "Filtros UV",
  "Conditioning Agents": "Agentes acondicionadores",
  "Personal Care Surfactants": "Surfactantes para el cuidado personal",
  "Printing Inks": "Tintas de impresión",
  "Solvent-Based Coatings": "Recubrimientos a base de solventes",
  "Water-Based Coatings": "Recubrimientos a base de agua",
  "Powder Coatings": "Recubrimientos en polvo",
  "Ink Additives": "Aditivos de tinta",
  "Printing Solvents": "Solventes de impresión",
  "Coating Resins": "Resinas de recubrimiento",
  "Flotation Reagents": "Reactivos de flotación",
  "Collectors": "Colectores",
  "Frothers": "espumadores",
  "Leaching Agents": "Agentes de lixiviación",
  "Dust Suppressants": "Supresores de polvo",
  "Ore Processing Flocculants": "Floculantes para procesamiento de minerales",
  "Tanning Agents": "Agentes bronceadores",
  "Textile Auxiliaries": "Auxiliares Textiles",
  "Bleaching Agents": "Agentes blanqueadores",
  "Sizing Chemicals": "Dimensionamiento de productos químicos",
  "Paper Additives": "Aditivos para papel",
  "Dye Fixing Agents": "Agentes fijadores de tintes",
  "Photoresists": "Fotorresistentes",
  "Etchants": "Grabadores",
  "Ultra-Pure Solvents": "Solventes ultrapuros",
  "Wafer Cleaning Chemicals": "Productos químicos para limpieza de obleas",
  "Electronic-Grade Acids": "Ácidos de grado electrónico",
  "Semiconductor Process Gases": "Gases de proceso de semiconductores",
  "Residential Water Tanks": "Tanques de agua residenciales",
  "Septic Systems": "Sistemas sépticos",
  "Rainwater Collection Barrels": "Barriles de recogida de agua de lluvia",
  "Household Water Filtration": "Filtración de agua doméstica",
  "Composting Toilets": "Inodoros de compostaje",
  "Greywater Systems": "Sistemas de aguas grises",
  "Prefabricated Room Modules": "Módulos de habitación prefabricados",
  "Modular Bathrooms": "Baños Modulares",
  "Container Home Modules": "Módulos de inicio de contenedores",
  "Prefabricated Kitchen Units": "Unidades de cocina prefabricadas",
  "Residential Pod Systems": "Sistemas de cápsulas residenciales",
  "Modular Stair Units": "Unidades de escalera modulares",
  "Ceiling Lights": "Luces de techo",
  "Pendant Lights": "Luces colgantes",
  "Wall Sconces": "Apliques de pared",
  "Floor and Table Lamps": "Lámparas de pie y de mesa",
  "Smart Bulbs": "Bombillas inteligentes",
  "Under-Cabinet Lighting": "Iluminación debajo del gabinete",
  "Residential Lighting Controls": "Controles de iluminación residencial",
  "Standard Light Bulbs": "Bombillas estándar",
  "Emergency Lighting": "Iluminación de emergencia",
  "Outdoor Lighting": "Iluminación exterior",
  "Flashlights and Portable Lighting": "Linternas e iluminación portátil",
  "Lamp Holders and Sockets": "Portalámparas y casquillos",
  "Motion-Sensor Lighting": "Iluminación con sensor de movimiento",
  "Pergolas": "Pérgolas",
  "Residential Fencing": "Cercado residencial",
  "Garden Gates": "Puertas de jardín",
  "Patio Structures": "Estructuras de patio",
  "Outdoor Privacy Screens": "Pantallas de privacidad al aire libre",
  "Raised Garden Beds": "Camas de jardín elevadas",
  "Planters and Garden Containers": "Jardineras y contenedores de jardín",
  "Residential Ramps": "Rampas residenciales",
  "Grab Bars": "Barras de apoyo",
  "Bathroom Safety Seats": "Asientos de seguridad para el baño",
  "Stair Lifts": "Elevadores de escaleras",
  "Threshold Ramps": "Rampas de umbral",
  "Tactile Home Indicators": "Indicadores táctiles de inicio",
  "Mobility Support Rails": "Rieles de soporte de movilidad",
  "Curtain Rods": "Barras de cortina",
  "Blinds and Shades": "Persianas y cortinas",
  "Decorative Mirrors": "Espejos Decorativos",
  "Wall Art Frames": "Marcos de arte de pared",
  "Rugs and Carpets": "Alfombras y Moquetas",
  "Home Textiles": "Textiles para el hogar",
  "Decorative Accessories": "Accesorios decorativos",
  "Window Treatments": "Tratamientos de ventanas",
  "Wooden Legs": "Patas de madera",
  "Metal Frames": "Marcos Metálicos",
  "Upholstery Fabrics": "Telas para tapicería",
  "Foam Cushions": "Cojines de espuma",
  "Drawer Slides": "Guías para cajones",
  "Cabinet Hinges": "Bisagras de gabinete",
  "Sinks": "Fregaderos",
  "Faucets": "Grifos",
  "Kitchen Cabinets": "Gabinetes de cocina",
  "Finished Countertops": "Encimeras terminadas",
  "Shower Heads": "Cabezales de ducha",
  "Bathtubs": "Bañeras",
  "Toilets": "Baños",
  "Vanities": "Vanidades",
  "Shower Enclosures": "Mamparas de ducha",
  "Kitchen Hardware": "Hardware de cocina",
  "Residential Radiators": "Radiadores residenciales",
  "Split Air Conditioners": "Aires acondicionados divididos",
  "Portable Air Conditioners": "Aires acondicionados portátiles",
  "Heat Pumps": "Bombas de calor",
  "Thermostats": "Termostatos",
  "Ventilation Fans": "Ventiladores de ventilación",
  "Bathroom Exhaust Fans": "Extractores de baño",
  "Smoke Detectors": "Detectores de humo",
  "Fire Extinguishers": "Extintores de incendios",
  "Residential Alarm Systems": "Sistemas de alarma residencial",
  "Security Cameras": "Cámaras de seguridad",
  "Video Doorbells": "Timbres con vídeo",
  "Motion Sensors": "Sensores de movimiento",
  "Home Safes": "Cajas fuertes para el hogar",
  "Smart Locks": "Cerraduras inteligentes",
  "Thermostat Sensors": "Sensores de termostato",
  "Lighting Controls": "Controles de iluminación",
  "Smart Plugs": "Enchufes inteligentes",
  "Smart Home Sensors": "Sensores de hogar inteligente",
  "Automation Hubs": "Centros de automatización",
  "Voice Control Devices": "Dispositivos de control de voz",
  "Steel Plates": "Placas de acero",
  "Aluminum Ingots": "Lingotes de aluminio",
  "Copper Rods": "Varillas de cobre",
  "Brass Alloys": "Aleaciones de latón",
  "Titanium Bars": "Barras de titanio",
  "Nickel Alloys": "Aleaciones de níquel",
  "Zinc Sheets": "Hojas de zinc",
  "PVC Resins": "Resinas de PVC",
  "ABS Plastics": "Plásticos ABS",
  "PET Granules": "Gránulos de PET",
  "Acrylic Sheets": "Hojas de acrílico",
  "Circuit Boards Raw": "Placas de circuito crudas",
  "Semiconductors Materials": "Materiales semiconductores",
  "LED Chips": "Fichas LED",
  "Capacitors Bases": "Bases de condensadores",
  "Resistors": "Resistencias",
  "Transistors": "Transistores",
  "Connectors": "Conectores",
  "Printed Circuit Boards": "Placas de circuito impreso",
  "Bearings Steel": "Rodamientos Acero",
  "Gears Alloys": "Aleaciones de engranajes",
  "Belts Rubber": "Cinturones De Goma",
  "Shafts": "Ejes",
  "Pulleys": "poleas",
  "Couplings": "Acoplamientos",
  "Seals and Gaskets": "Sellos y juntas",
  "Natural Rubber": "Caucho natural",
  "Synthetic Rubber": "Caucho Sintético",
  "Carbon Fiber": "Fibra de carbono",
  "Fiberglass": "Fibra de vidrio",
  "Epoxy Resins": "Resinas Epoxi",
  "Kevlar": "kevlar",
  "Rubber Sheets": "Hojas de caucho",
  "Composite Panels": "Paneles compuestos",
  "Pliers": "Alicates",
  "Cutters": "Cortadores",
  "Files": "Limas",
  "Chisels": "Cinceles",
  "Measuring Tapes": "Cintas métricas",
  "Levels": "Niveles",
  "Utility Knives": "Cuchillos utilitarios",
  "Wrenches": "llaves",
  "Screwdrivers": "Destornilladores",
  "Hammers": "Martillos",
  "Clamps": "Abrazaderas",
  "Electric Drills": "Taladros electricos",
  "Angle Grinders": "Amoladoras angulares",
  "Circular Saws": "Sierras circulares",
  "Impact Wrenches": "Llaves de impacto",
  "Sanders": "Lijadoras",
  "Routers": "Fresadoras",
  "Jigsaws": "Rompecabezas",
  "Drill Bits": "Brocas",
  "Abrasive Discs": "Discos Abrasivos",
  "Wire and Abrasive Brushes": "Cepillos de alambre y abrasivos",
  "Grinding Stones": "Piedras de moler",
  "Masonry Tools": "Herramientas de albañilería",
  "Long-Handle Tools": "Herramientas de mango largo",
  "Hand Saws and Hacksaws": "Sierras de mano y sierras para metales",
  "Woodworking Planes": "Aviones para trabajar la madera",
  "Staplers and Nailers": "Grapadoras y clavadoras",
  "Tile Cutters": "Cortadores de azulejos",
  "Riveters": "Remachadoras",
  "Tool Sets": "Juegos de herramientas",
  "Sockets and Ratchets": "Vasos y trinquetes",
  "Hole Saws": "Sierras perforadoras",
  "Bulldozers": "topadoras",
  "Cranes": "Grúas",
  "Forklifts": "Carretillas elevadoras",
  "Loaders": "Cargadores",
  "Compactors": "Compactadores",
  "Drilling Rigs": "Equipos de perforación",
  "FIBC and Big Bags": "FIBC y Big Bags",
  "Stretch Wrap": "Envoltura elástica",
  "Shrink Film": "Película retráctil",
  "Protective Film": "Película protectora",
  "Food-Grade Film": "Película de calidad alimentaria",
  "Strapping Materials": "Materiales para flejes",
  "Cardboard Boxes": "Cajas de Cartón",
  "Drums and Barrels": "Tambores y barriles",
  "Hard Hats": "Cascos duros",
  "Bump Caps": "Tapas protectoras",
  "Ventilated Helmets": "Cascos ventilados",
  "High-Visibility Helmets": "Cascos de alta visibilidad",
  "Electrical Insulation Helmets": "Cascos de aislamiento eléctrico",
  "Mining Helmets": "Cascos Mineros",
  "Safety Gloves": "Guantes de seguridad",
  "Protective Eyewear": "Gafas protectoras",
  "Ear Protection": "Protección auditiva",
  "Respirators": "respiradores",
  "Safety Boots": "Botas de seguridad",
  "Harness Systems": "Sistemas de arnés",
  "First Aid Kits": "Botiquines de primeros auxilios",
  "Welding Masks": "Máscaras de soldadura",
  "High-Visibility Vests": "Chalecos de alta visibilidad",
  "Protective Rainwear": "Ropa protectora para la lluvia",
  "Safety Signs": "Señales de seguridad",
  "Traffic and Safety Barriers": "Barreras de tráfico y seguridad",
  "Barrier and Warning Tape": "Cinta de barrera y advertencia",
  "Knee and Elbow Protection": "Protección de rodillas y codos",
  "Disposable Biosecurity Equipment": "Equipos de Bioseguridad Desechables",
  "Face Shields": "Escudos faciales",
  "Calipers": "Calibrador",
  "Micrometers": "micrómetros",
  "Multimeters": "Multímetros",
  "Thermometers": "Termómetros",
  "Pressure Gauges": "Manómetros",
  "Oscilloscopes": "Osciloscopios",
  "Hardness Testers": "Probadores de dureza",
  "Hoists": "Polipastos",
  "Slings": "Eslingas",
  "Shackles": "Grilletes",
  "Winches": "Cabrestantes",
  "Chain Blocks": "Bloques de cadena",
  "Lifting Beams": "Vigas de elevación",
  "Tackle Systems": "Sistemas de aparejos",
  "Centrifugal Pumps": "Bombas centrífugas",
  "Diaphragm Pumps": "Bombas de diafragma",
  "Gate Valves": "Válvulas de compuerta",
  "Ball Valves": "Válvulas de bola",
  "Check Valves": "Válvulas de retención",
  "Solenoid Valves": "Válvulas solenoides",
  "Pump Motors": "Motores de bomba",
  "Belt Conveyors": "Transportadores de banda",
  "Roller Conveyors": "Transportadores de rodillos",
  "Screw Conveyors": "Transportadores de tornillo",
  "Pallet Jacks": "Transpaletas",
  "Hand Trucks": "carretillas de mano",
  "Stackers": "Apiladores",
  "Automated Guided Vehicles": "Vehículos guiados automatizados",
  "Handling Trolleys": "Carros de manipulación",
  "Conveyor Belts": "Cintas transportadoras",
  "Welding Electrodes": "Electrodos de soldadura",
  "MIG Welders": "Soldadores MIG",
  "TIG Welders": "Soldadores TIG",
  "Plasma Cutters": "Cortadores de plasma",
  "Oxy-Acetylene Torches": "Antorchas de oxiacetileno",
  "Filler Metals": "Metales de aporte",
  "Welding Accessories and Spare Parts": "Accesorios y repuestos para soldadura",
  "Arc and Stick Welders": "Soldadores de arco y electrodo",
  "Welding Torches": "Antorchas de soldadura",
  "Regulators and Welding Hoses": "Reguladores y Mangueras de Soldadura",
  "Gas Welding Equipment": "Equipos de soldadura de gas",
  "Welding Clamps and Holders": "Abrazaderas y soportes para soldadura",
  "Welding PPE Kits": "Kits de EPI para soldadura",
  "Air Compressors": "Compresores de aire",
  "Pneumatic Cylinders": "Cilindros neumáticos",
  "Air Hoses": "Mangueras de aire",
  "Filters and Regulators": "Filtros y Reguladores",
  "Pneumatic Tools": "Herramientas neumáticas",
  "Vacuum Pumps": "Bombas de vacío",
  "Diesel Generators": "Generadores diésel",
  "Gasoline Generators": "Generadores de gasolina",
  "Inverters": "Inversores",
  "Battery Packs": "Paquetes de baterías",
  "Solar Panels for Equipment": "Paneles solares para equipos",
  "Power Distribution Units": "Unidades de distribución de energía",
  "PLCs": "PLC",
  "Sensors": "Sensores",
  "Actuators": "Actuadores",
  "Relays": "Relés",
  "Control Panels": "Paneles de control",
  "Robotic Arms Components": "Componentes de brazos robóticos",
  "HMI Screens": "Pantallas HMI",
  "Industrial Networks": "Redes Industriales",
  "Machine Vision": "Visión artificial",
  "Safety Controllers": "Controladores de seguridad",
  "Door and Gate Automation": "Automatización de puertas y portones",
  "Access Control Systems": "Sistemas de control de acceso",
  "Motor Controls and Accessories": "Controles y accesorios de motores",
  "Automation Spare Parts": "Repuestos de automatización",
  "Garage and Industrial Door Operators": "Operadores de puertas de garaje y industriales",
  "AC Electric Motors": "Motores eléctricos de CA",
  "DC Electric Motors": "Motores eléctricos de CC",
  "Servo Motors": "Servomotores",
  "Gearboxes": "Cajas de cambios",
  "Industrial Chains": "Cadenas Industriales",
  "Sprockets": "Piñones",
  "Power Transmission Belts": "Correas de transmisión de potencia",
  "Variable Frequency Drives": "Variadores de frecuencia",
  "Industrial Lathes": "Tornos industriales",
  "Milling Machines": "Fresadoras",
  "CNC Routers": "Enrutadores CNC",
  "Machining Centers": "Centros de mecanizado",
  "Industrial Presses": "Prensas industriales",
  "Metal Cutting Machines": "Máquinas cortadoras de metales",
  "Tool Holders": "Portaherramientas",
  "Industrial Boilers": "Calderas Industriales",
  "Chillers": "Enfriadores",
  "Heat Exchangers": "Intercambiadores de calor",
  "Cooling Towers": "Torres de enfriamiento",
  "Industrial Burners": "Quemadores Industriales",
  "Process Heaters": "Calentadores de proceso",
  "Industrial Refrigeration Units": "Unidades de refrigeración industriales",
  "Industrial Racks": "Bastidores industriales",
  "Shelving Systems": "Sistemas de estanterías",
  "Storage Bins": "Contenedores de almacenamiento",
  "Warehouse Mezzanines": "Entrepisos de almacén",
  "Dock Equipment": "Equipo de muelle",
  "Workbenches": "Bancos de trabajo",
  "Industrial Ladders": "Escaleras Industriales",
  "Tool Boxes and Chests": "Cajas y cofres de herramientas",
  "Tool Bags and Backpacks": "Bolsas y mochilas para herramientas",
  "Small Parts Organizers": "Organizadores de piezas pequeñas",
  "Industrial Cabinets and Lockers": "Armarios y taquillas industriales",
  "Tool Holders and Belts": "Portaherramientas y cinturones",
  "Industrial Filters": "Filtros industriales",
  "Lubrication Systems": "Sistemas de lubricación",
  "Replacement Blades": "Cuchillas de repuesto",
  "Machine Guards": "Protectores de máquinas",
  "Maintenance Kits": "Kits de mantenimiento",
  "Replacement Hoses": "Mangueras de repuesto",
  "Industrial Seals": "Sellos industriales",
  "Pressure Washers": "Lavadoras a presión",
  "Floor Scrubbers": "Fregadores de pisos",
  "Industrial Vacuums": "Aspiradoras industriales",
  "Steam Cleaners": "Limpiadores a vapor",
  "Parts Washers": "Lavadoras de piezas",
  "Industrial Sweepers": "Barredoras industriales",
  "Brooms, Brushes and Dustpans": "Escobas, cepillos y recogedores",
  "Mops and Wringers": "Trapeadores y escurridores",
  "Sponges and Scouring Pads": "Esponjas y estropajos",
  "Janitorial Carts": "Carros de limpieza",
  "Restroom Cleaning Equipment": "Equipo de limpieza de baños",
  "Cleaning Buckets and Containers": "Cubetas y recipientes de limpieza",
};
